import glamorous from 'glamorous';

import { media } from '../../../styles';

const NavRight = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 2,
  alignItems: 'center',
  justifyContent: 'space-between',
  marginLeft: 16,

  [media('sm', { isMax: true })]: {
    justifyContent: 'flex-end',
  },
});

export default NavRight;



// WEBPACK FOOTER //
// ./src/components/layout/Nav/NavRight.js